import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Box, Drawer, IconButton } from "@mui/material";
import Iconify from "src/components/iconify/Iconify";
import useResponsive from "../../../hooks/useResponsive";
import Logo from "../../../components/logo";
import Scrollbar from "../../../components/scrollbar";
import NavSection from "../../../components/nav-section";
import { navSections } from "./mainConfig";

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {
  const NAV_WIDTH = 220;
  const COLLAPSE_WIDTH = 80;
  const { pathname } = useLocation();
  const isDesktop = useResponsive("up", "lg");

  const [collapse, setCollapse] = useState(false);

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Box
        sx={{
          p: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "relative",
        }}
      >
        <Box
          sx={{
            opacity: collapse ? 0 : 1,
            transition: collapse
              ? "opacity 0.15s ease-in-out"
              : "opacity 0.2s ease-in-out 0.3s",
            visibility: collapse ? "hidden" : "visible",
            flex: collapse ? 0 : 1,
            minWidth: collapse ? 0 : "auto",
            overflow: "hidden",
          }}
        >
          <Logo />
        </Box>
        <IconButton
          onClick={() => setCollapse((prev) => !prev)}
          sx={{
            position: collapse ? "absolute" : "static",
            left: collapse ? "50%" : "auto",
            transform: collapse ? "translateX(-50%)" : "none",
          }}
        >
          <Iconify
            icon={
              collapse
                ? "eva:arrow-ios-forward-fill"
                : "eva:arrow-ios-back-fill"
            }
          />
        </IconButton>
      </Box>
      {navSections.map((section) => (
        <NavSection
          key={section.title}
          data={section.items}
          title={section.title}
          collapse={collapse}
        />
      ))}
      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: collapse ? COLLAPSE_WIDTH : NAV_WIDTH },
        transition: (theme) =>
          theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.standard,
          }),
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: collapse ? COLLAPSE_WIDTH : NAV_WIDTH,
              bgcolor: "background.default",
              borderRightStyle: "dashed",
              overflowX: "hidden",
              transition: (theme) =>
                theme.transitions.create("width", {
                  easing: theme.transitions.easing.sharp,
                  duration: theme.transitions.duration.standard,
                }),
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{ keepMounted: true }}
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
